export type InvestmentCurrency = 'EUR' | 'USD';

export const CURRENCY_SYMBOLS: Record<InvestmentCurrency, string> = {
	EUR: '€',
	USD: '$',
};

export const CURRENCY_OPTIONS: { label: string; value: InvestmentCurrency }[] = [
	{ label: 'Euro (€)', value: 'EUR' },
	{ label: 'Dólar ($)', value: 'USD' },
];

export interface Investment {
	id?: any;
	uuid?:any;
	reference?: string;
	name?: string;
	image?: string;
	interest?: number;
	amount?: number;
	currency?: InvestmentCurrency;
	cancellation_hours?: number;
	status?: number | boolean;
	user_id?:any,
	start_date?:any,
	end_date?:any,
	description?:any,
}
